import React from "react";
import { formatSalesValue } from "../../../utils/formatUtils";
import { adToBs } from "@sbmdkl/nepali-date-converter";
import { formatNepaliDateYear, formatToISODate } from "../../../utils/formateDateUtils";

const calculateTotal = (list, getter) =>
    list.reduce((sum, item) => sum + Number(getter(item) || 0), 0);

const PurchaseVATTable = ({ purchaseRequisitions = [] }) => {
    return (
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="max-h-[550px] overflow-auto tiny-scrollbar">
                <table className="min-w-full border-collapse text-sm text-center">
                    <thead className="sticky top-0 z-10 bg-gray-100">
                        <tr className="border-b border-gray-200">
                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Date
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Vendor
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                VAT
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Total
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                GRN
                            </th>

                            <th className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600">
                                Bill No.
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {purchaseRequisitions.length === 0 && (
                            <tr>
                                <td
                                    colSpan={6}
                                    className="py-6 text-center text-sm text-gray-500"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}

                        {purchaseRequisitions.map((item, index) => (
                            <tr
                                key={item.IDIntbl_PurchaseRequisition ?? index}
                                className="border-b border-gray-100 transition-colors hover:bg-gray-50"
                            >
                                <td className="whitespace-nowrap p-2 text-gray-700">
                                    {formatNepaliDateYear(adToBs(formatToISODate(item.ReceivedDate)))}
                                </td>

                                <td className="whitespace-nowrap p-2 text-gray-700">
                                    {item.Company_Name || "N/A"}
                                </td>

                                <td className="p-2 text-gray-700">
                                    {item.TaxAmount || "0.00"}
                                </td>

                                <td className="p-2 font-semibold text-gray-900">
                                    {formatSalesValue(item.TotalAmount) || "0.00"}
                                </td>

                                <td className="whitespace-nowrap p-2 text-gray-700">
                                    {item.GRN || "N/A"}
                                </td>

                                <td className="whitespace-nowrap p-2 text-gray-700">
                                    {item.purchaseBillNumber}
                                </td>
                            </tr>
                        ))}
                    </tbody>

                    {purchaseRequisitions.length > 0 && (
                        <tfoot className="sticky bottom-0 bg-gray-100">
                            <tr className="border-t border-gray-200">
                                <td className="p-2 font-semibold text-gray-900">
                                    Count: {purchaseRequisitions.length}
                                </td>

                                <td></td>

                                <td className="p-2 font-semibold text-gray-900">
                                    {formatSalesValue(
                                        calculateTotal(
                                            purchaseRequisitions,
                                            (i) => i.TaxAmount
                                        )
                                    )}
                                </td>

                                <td className="p-2 font-semibold text-gray-900">
                                    {formatSalesValue(
                                        calculateTotal(
                                            purchaseRequisitions,
                                            (i) => i.TotalAmount
                                        )
                                    )}
                                </td>

                                <td colSpan={2}></td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>
        </div>
    );
};

export default PurchaseVATTable;